import { useWindowSize } from '../hooks/useWindowResize';

export const IsMobile = () => {
  const size = useWindowSize();
  return size.width <= 768;
};
